'use client';

import { Component, createContext, ErrorInfo, ReactNode } from 'react';
import { translateInline } from '../translate/translateInline';
import { appStateTranslations } from '@dop/shared/translate/appStateTranslations';

export const ErrorFallback = () => {
	return <p>{translateInline(appStateTranslations.errorBoundaryFailed)}</p>;
};

export const ErrorBoundaryContext = createContext<Error | undefined>(undefined);

type ErrorBoundaryProps = {
	children: ReactNode;
	fallback: ReactNode;
};

/**
 * ErrorBoundary component to catch errors in the component tree.
 * It uses ErrorBoundaryContext to provide the error to the fallback component.
 */
export class ErrorBoundary extends Component<
	ErrorBoundaryProps,
	{ didCatch: true; error: Error } | { didCatch: false }
> {
	constructor(props: ErrorBoundaryProps) {
		super(props);

		this.state = { didCatch: false };
	}
	componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
		this.setState({ didCatch: true, error });
		console.error(error, errorInfo);
	}
	render(): ReactNode {
		return this.state.didCatch ? (
			<ErrorBoundaryContext value={this.state.error}>
				{this.props.fallback}
			</ErrorBoundaryContext>
		) : (
			this.props.children
		);
	}
}
